import { BoxModel } from '@fox/blocks';
import { ISection } from './components/blocks/section-block/contracts';
import { SURVEY_BUTTON_NEXT_BLOCK_TYPE, SURVEY_BUTTON_PREVIOUS_BLOCK_TYPE, SURVEY_BUTTON_SUBMIT_BLOCK_TYPE } from './form-block-types';

//temporarily a copy of utils in @fox/canvas, as more things move over we will remove the old one
//we might actually want this all in blocks
const DEFAULT_PADDING = { padding: 10, margin: 0 };

const typeAttributeMapping = {
	columns: { padding: 0, margin: 0, columnStackingMode: 'no-stack' },
	button: DEFAULT_PADDING,
	attachment: DEFAULT_PADDING,
	survey: DEFAULT_PADDING,
	[SURVEY_BUTTON_NEXT_BLOCK_TYPE]: DEFAULT_PADDING,
	[SURVEY_BUTTON_PREVIOUS_BLOCK_TYPE]: DEFAULT_PADDING,
	[SURVEY_BUTTON_SUBMIT_BLOCK_TYPE]: DEFAULT_PADDING,
	rsvp: DEFAULT_PADDING,
	eventcalendar: DEFAULT_PADDING
};

const convertLegacyPadding = props => {
	if (!props.padding && !props.paddingVertical) {
		return 0;
	}

	const padding = props.padding ?? 0;
	const paddingVertical = props.paddingVertical ?? props.padding ?? 0;

	return {
		top: paddingVertical,
		bottom: paddingVertical,
		left: padding,
		right: padding
	};
};

export const transformLegacyProps = (type: string, props) => {
	if ('attributes' in props) {
		return props;
	}

	const defaultAttributes = { padding: 0 };
	const attributes = { ...(typeAttributeMapping[type] ?? defaultAttributes) };

	attributes.padding = convertLegacyPadding(props);

	return {
		...props,
		attributes: attributes
	};
};

export const getAttributeValues = (attribute: BoxModel | undefined) => {
	if (typeof attribute === 'number') {
		return {
			top: attribute,
			bottom: attribute,
			right: attribute,
			left: attribute
		};
	}
	const { top = 0, bottom = 0, left = 0, right = 0 } = attribute ?? {};

	return {
		top,
		bottom,
		left,
		right
	};
};
/**
 * @param sections - The form sections containing all the form fields.
 * @param dependsOn - The field types that the block depends on.
 * @returns
 */
export const findRenderDependencies = (sections: ISection[], dependsOn: string[]): string[] => {
	const dependencies: string[] = [];
	sections.forEach(section => {
		section.fields.forEach(field => {
			if (dependsOn.includes(field.type)) {
				dependencies.push(field.name);
			}
		});
	});
	return dependencies;
};
